import { Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Navigation } from '@components';
import { ErrorCode } from '@constants';
import { ErrorPage } from '../error';
import classes from './index.module.css';

export const Layout = () => {
  const { pathname } = useLocation();
  const { email } = useSelector((state) => state.policy);
  const isLoginPage = ['/', '/17track'].includes(pathname);
  return (
    <>
      <Navigation />
      <div className={classes.placeholder} />
      <div className={classes.content}>
        {(email || isLoginPage) ? <Outlet /> : <ErrorPage code={ErrorCode.Refresh} />}
      </div>
    </>
  );
};
